import React from 'react'
import { categories, prosodies } from 'keys'
import { keyBy } from 'lodash'
import { Tooltip } from '@mui/material'

const ProsodyCell = (props) => {
    const { cell, row } = props
    const { reading_assessment_category_name, reading_assessment_category_label } = row.original
    let value = cell.getValue()

    const prosodyKeys = keyBy(prosodies, "id")
    const prosody = prosodyKeys[value]

    let Icon = prosody?.icon
    let label = ""
    let tooltip = prosody?.name
    if (!value)
        if (reading_assessment_category_name != categories.INFORMATIONAL_TEXT && reading_assessment_category_name != categories.NARRATIVE_TEXT && reading_assessment_category_name != categories.NARRATIVE_TEXT_NO_NIKUD) {
            label = "א/נ"
            tooltip = `לא נמדד במבדק מסוג ${reading_assessment_category_label}`
        }

    return (
        <Tooltip title={tooltip} placement='top'>
            {value ?
                <Icon fontSize='small' sx={{ color: prosody?.borderColor }} />
                :
                label}
        </Tooltip>
    )
}

export default ProsodyCell